
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export function SkipContentAccessibility() {
  const { t  } = useTranslation();
  const { pathname } = useLocation();
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    const el = document.getElementById("button-main-content");
    if (el) {
      el.focus();
    }
  }, [pathname]);

  return (
    <a
      id="button-main-content"
      role="button"
      href="#main-content"
      aria-label={ t("skip_content") }
      tabIndex={ 0 }
      onFocus={ () => setFocused(true) }
      onBlur={ () => setFocused(false) }
      style={ {
        position: focused ? "static" : "absolute",
        width:"1px",
        height: "1px",
        overflow: focused ? "visible" : "hidden",
        clip: focused ? "auto" : "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap"
      } }
    >
    </a>
  );
}
